<script setup lang="ts">
import { computed } from 'vue'
import { useRouteLocalizedPath } from '~/composables/useRouteLocalizedPath'

const props = defineProps<{
    to: string
}>()

const localizedPath = useRouteLocalizedPath()
const target = computed(() => localizedPath(props.to))
</script>

<template>
    <NuxtLink :to="target">
        <slot />
    </NuxtLink>
</template>
